import { createWithEqualityFn } from "zustand/traditional";
import { shallow } from "zustand/shallow";
import { APIRequest } from "@companion-core/shared/app/Interfaces/API";

type ValidationStatus = "success" | "error" | null;

interface MemberState {
  requests: APIRequest[] | null;
  lastConnectionDate: string | null;
  validationStatus: ValidationStatus;
  validationMessage: string | null;
}

interface MemberActions {
  setMemberRequests: (requests: APIRequest[] | null) => void;
  setValidationStatus: (status: ValidationStatus) => void;
  setValidationMessage: (message: string | null) => void;
  resetValidationBanner: () => void;
  resetMember: () => void;
}

export const initialState: MemberState = {
  requests: null,
  lastConnectionDate: null,
  validationStatus: null,
  validationMessage: null,
};

export const useMemberStore = createWithEqualityFn<MemberState & MemberActions>()(
  (set) => ({
    ...initialState,
    setMemberRequests: (requests: APIRequest[] | null) => set({ requests }),
    setValidationStatus: (status: ValidationStatus) => set({ validationStatus: status }),
    setValidationMessage: (message: string | null) => set({ validationMessage: message }),
    resetValidationBanner: () => set({ validationStatus: null, validationMessage: null }),
    resetMember: () => set(initialState),
  }),
  shallow
);
